var map = {
	"./bs_web_stitch_base01_.png": 714190,
	"./bs_web_stitch_base01_blk.png": 318337,
	"./bs_web_stitch_base01_blu.png": 505855,
	"./bs_web_stitch_base01_cml.png": 277684,
	"./bs_web_stitch_base01_crk.png": 116869,
	"./bs_web_stitch_base01_grn.png": 144307,
	"./bs_web_stitch_base01_lgd.png": 746781,
	"./bs_web_stitch_base01_lsl.png": 424193,
	"./bs_web_stitch_base01_nvy.png": 221485,
	"./bs_web_stitch_base01_orn.png": 236795,
	"./bs_web_stitch_base01_pnk.png": 784041,
	"./bs_web_stitch_base01_ppl.png": 303512,
	"./bs_web_stitch_base01_red.png": 404497,
	"./bs_web_stitch_base01_sax.png": 650596,
	"./bs_web_stitch_base01_wht.png": 551951,
	"./bs_web_stitch_base01_ylw.png": 839486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332745;